<template>
  <div>
    <el-row>
      <el-col :span="14">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="送货日期：">
            <el-date-picker v-model="searchForm.date" type="date" placeholder="选择日期" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button v-preventReClick @click="this.queryTable" style="float:right" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2">
        <el-button v-preventReClick @click="mathTable">带函数导出</el-button>
      </el-col>
      <el-col :span="2">
        <el-button v-preventReClick @click="enterTable">导入</el-button>
      </el-col>
      <el-col :span="2">
        <el-button v-preventReClick @click="exportTable">导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10">
        <span>{{this.name}}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :data="tableData" v-for="item in tableData" :key="item.INCOME_DATE">
        <table cellpadding="0" cellspacing="0" style="width:100%" class="sending">
          <caption class="table-title" style="">{{item.CNAME}}</caption>
          <tr style="width:100%">
            <td style="width:100%">
              <table cellpadding="0" cellspacing="0" style="width:100%">
                <tr class="table-line">
                  <td class="product-title" style="width:30%">品名</td>
                  <td class="product-title" style="width:100px;text-align:center">单位</td>
                  <td class="product-title" style="width:30%;text-align:center">分量</td>
                  <td class="product-title" style="width:10%;text-align:center">总量</td>
                  <td class="product-title" style="width:100px;text-align:center">单价</td>
                  <td class="product-title" style="width:10%;text-align:center">合计</td>
                </tr>
                <tr class="table-line">
                  <td class="product-title" style="width:30%">品名</td>
                  <td class="product-title" style="width:100px;text-align:center">单位</td>
                  <td class="product-title" style="width:30%;text-align:center">分量</td>
                  <td class="product-title" style="width:10%;text-align:center">总量</td>
                  <td class="product-title" style="width:100px;text-align:center">单价</td>
                  <td class="product-title" style="width:10%;text-align:center;border:0">合计</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr class="table-line" v-for="index in item.DATA" :key="index.INCOME_DATE">
            <td class="product" style="width:30%;">{{index.N}}</td>
            <td class="product" style="width:100px;text-align:center">{{index.U}}</td>
            <td class="product" style="width:30%;text-align:center">{{index.D}}</td>
            <td class="product" style="width:10%;text-align:center">{{index.T}}</td>
            <td class="product" style="width:100px;text-align:center">{{index.P}}</td>
            <td class="product" style="width:10%;text-align:center">{{index.W}}</td>
          </tr>
          <tr style="width:100%">
            <td style="width:100%">
              <table cellpadding="0" cellspacing="0" style="width:100%">
                <tr class="table-line">
                  <td class="product-title" style="width:90.1%">总计</td>
                  <td class="product-title" style="width:100px;text-align:center">{{item.SUM}}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-dialog title="上传成本数据" center :visible.sync="addFormVisible" @close="addFormVisible = false" width="600px">
      <el-form ref="addForm" v-model="addForm">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" :name="this.addForm.price" multiple
          :file-list="fileList">
          <el-button v-preventReClick size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="close('addForm')">取 消</el-button>
        <el-button v-preventReClick @click="submitEnter('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import date from "@/assets/common/date";
import http from "@/assets/common/http";

export default {
  data() {
    return {
      loadSearch: false,
      searchForm: {
        date: date(new Date(), '%F'),
      },
      tableData: [],
      addForm: {
        price: 'tmp',
      },
      fileList: [],
      addFormVisible: false,
      url: '',
      name: '',
    };
  },
  methods: {
    queryTable() {
      const params = {
        SERVICE_ID: '10080',
        OTYPE: 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.date, '%F'),
      };
      this.loadSearch = true;
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].DATA;
          this.name = result[0].COMPANY_NAME;
          this.loadSearch = false;
        } else {
          this.$message.show({ text: '暂无数据', type: 'error' });
          this.loadSearch = false;
        }
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportTable() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10080',
            OTYPE: 2,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    mathTable() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10080',
            OTYPE: 2,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
            FORMULA_FLAG: 1,
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    enterTable() {
      this.addFormVisible = true;
    },
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.fileList = [];
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    removeFile(file, fileList) {
      this.remove = file.uid;
      this.idArray.push({ ID: this.remove });
    },
    submitEnter() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
            FILE_NAME: this.url,
            SERVICE_ID: '10080',
            OTYPE: 3,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.addFormVisible = false;
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
  },
  created() {
    this.queryTable();
  },
};
</script>
<style scoped>
.product {
  color: #606266;
  padding-left: 5px;
  height: 40px;
}
.table-title {
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
  color: #909399;
  font-weight: bold;
  border-bottom: 0;
}
.table-line {
  float: left;
  width: 50%;
  border-bottom: 0px;
}
.sending,
.sending tr th,
.sending tr td {
  border: 1px solid #ebeef5;
}
.product-title {
  border-top: 0 !important;
  border-bottom: 0 !important;
  color: #606266;
  padding-left: 5px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/supplierPrice.vue